import { render, staticRenderFns } from "./05huanghuacai.vue?vue&type=template&id=3dc12d14&scoped=true&"
import script from "./05huanghuacai.vue?vue&type=script&lang=js&"
export * from "./05huanghuacai.vue?vue&type=script&lang=js&"
import style0 from "./05huanghuacai.vue?vue&type=style&index=0&id=3dc12d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc12d14",
  null
  
)

export default component.exports